import { ZOOM_10 } from '@/utils/constants/map';

export const getTrainRenderInterval = (zoom: number) => {
  if (zoom < ZOOM_10) {
    return 1000;
  }

  if (zoom >= ZOOM_10 && zoom <= 11) {
    return 3000;
  }

  return 1000;
};
